import { Text } from '../elements/text.element';

/**
 * 👁️ Staff-only viewing tools. Kept in a separate file from
 * persona-switcher.block.jsx on purpose.
 *
 * The two controls sit inches apart in the same menu and mean very different
 * things, so the separation is in the code as well as the layout:
 *
 *   Working as…   (persona switcher)  You, wearing a different hat.
 *   View as…      (this)              Somebody who is not you.
 *
 * Collapsing them into one list would put "Customer" (a hat you hold) next to
 * "Guest" (a state you cannot be in while signed in) and next to another
 * person's account (which needs approval and is audited) as if they were three
 * options of the same kind. They are not, and the person clicking has to be
 * able to tell.
 */
export const StaffViewAs = ({ canPreviewAsGuest, onGuestPreview, onDone }) => {
  if (!canPreviewAsGuest) return null;

  return (
    <div className="px-2 pb-1 border-b border-gray-100 mb-1">
      <Text variant="label" className="px-2 pt-2 pb-1 block uppercase tracking-wider text-[10px] text-gray-400">
        View as · staff tools
      </Text>

      <button
        type="button"
        onClick={() => { onGuestPreview?.(); onDone?.(); }}
        role="menuitem"
        className="w-full text-left px-3 py-1.5 rounded-xl text-gray-600 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2.5">
          <span className="w-2 h-2 rounded-full flex-shrink-0 border-2 border-dashed border-gray-400 bg-background" aria-hidden="true" />
          <span className="flex-1 text-sm">Guest (signed out)</span>
        </div>
        <p className="mt-0.5 pl-[18px] pr-1 text-[10px] leading-snug text-gray-400">
          See the public site as a visitor. You stay signed in.
        </p>
      </button>

      {/* Impersonation is NOT offered here. It needs a target, a reason and an
          approval, so it belongs in the identity console next to the audit
          trail that records it — not one click from "Guest" in a dropdown. */}
      <p className="px-3 pt-1 pb-1 text-[10px] leading-snug text-gray-400">
        To view a specific person’s account, use Support Session in the{' '}
        <span className="font-semibold">user registry</span> — it needs a reason and is audited.
      </p>
    </div>
  );
};

export default StaffViewAs;
